import {isUnitFaction} from "../isUnitFaction";
import {FACTIONS} from "../../../constants/factions";

export const isUnitInsectoid = (unit) => isUnitFaction(unit, FACTIONS.INSECTOIDS);
